export const exportDataToCsv = (
  fileName: string,
  headers: readonly string[],
  data: Record<string, unknown>[],
  rowMapper: (
    item: Record<string, unknown>,
  ) => (string | number | boolean | null | undefined)[],
): void => {
  const csvRows: string[] = [];

  csvRows.push(headers.join(','));

  for (const item of data) {
    const row = rowMapper(item);
    const escapedRow = row.map((value) => {
      if (value === null || value === undefined) {
        return '""';
      }
      return `"${String(value).replace(/"/g, '""')}"`;
    });
    csvRows.push(escapedRow.join(','));
  }

  // Create and download file
  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.csv`;
  link.click();

  URL.revokeObjectURL(link.href);
};
